import script from "./CertificatesList.vue?vue&type=script&setup=true&lang=ts"
export * from "./CertificatesList.vue?vue&type=script&setup=true&lang=ts"

import "./CertificatesList.vue?vue&type=style&index=0&id=67fa4342&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67fa4342"]])

export default __exports__